export function getUrlWithLocale(
  url: string | undefined,
  locale: string | null,
): string | undefined {
  if (!url || !locale) return url;
  const tos = url.split('/').slice(-1)[0];
  return url.replace(tos, `${locale}/${tos}`);
}
